import { cronForm } from './CronFields'
import { eventRouteForm } from './EventRouteFields'
import { fallbackForm } from './FallbackFields'
import { githubForm } from './GitHubFields'
import { gitRepoForm } from './GitRepoFields'
import { noteForm } from './NoteFields'
import { planForm } from './PlanFields'
import { questionForm } from './QuestionFields'
import { recipeForm } from './RecipeFields'
import { sqliteForm } from './SqliteFields'
import type { ResourceFormDescriptor } from './shared'
import { todoForm } from './TodoFields'
import { urlForm } from './UrlFields'
import { webhookForm } from './WebhookFields'
import { workflowForm } from './WorkflowFields'

/**
 * Per-kind form descriptor, mirroring the `resources/` viewer registry on the
 * read side. Adding a kind = add a descriptor here; `ResourceFormPage` needs no
 * kind-specific knowledge.
 */
const RESOURCE_FORMS: Record<string, ResourceFormDescriptor> = {
  web: urlForm,
  mcp: urlForm,
  sqlite_db: sqliteForm,
  note: noteForm,
  git_repo: gitRepoForm,
  github: githubForm,
  event_route: eventRouteForm,
  workflow: workflowForm,
  recipe: recipeForm,
  webhook: webhookForm,
  cron: cronForm,
  todo_list: todoForm,
  plan: planForm,
  question: questionForm,
}

/**
 * Never undefined: kinds without a hand-written form fall back to a generic
 * JSON editor over the full `data` blob, so editing an existing resource
 * always shows (and saves) more than its name.
 */
export function getResourceForm(kind: string): ResourceFormDescriptor {
  return RESOURCE_FORMS[kind] ?? fallbackForm
}
